import React, {useContext} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {SettingsContext} from "@/SettingsContext";
import {useTranslation} from "react-i18next";
import Logo from "@/components/Logo";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import Info from "@/pages/Info";
import {useOverlay} from "@/OverlayContext";

const Menu = ({ toggleMenu }) => {

    const { tourSettings } = useContext(SettingsContext);
    const params = useParams();
    const navigate = useNavigate();

    const { t } = useTranslation();
    const { setOverlay, setOverlayIsVisible } = useOverlay();

    function showInfo() {
        console.log("showInfo");
        setOverlay(
            <Info onContentLoaded={() => {
                console.log("Info content loaded");
                toggleMenu();
                setOverlayIsVisible(true);
            }} />
        );

    }

    function showPoints() {
        toggleMenu();
        navigate(`/${params.language ? `${params.language}/` : ''}points`);
    }

    return (
                <div className="text-black h-full w-full absolute inset-0 z-50" style={{
                    backgroundColor: (tourSettings?.header_background_color) ? tourSettings.header_background_color : '#ffffff',
                    color: (tourSettings.header_text_color) ? tourSettings.header_text_color : '#000000'
                }}>
                    <div className="p-2 px-4">

                    <div className="flex h-16 justify-between ">
                        <div className=" flex">
                            <div className="flex flex-shrink-0 items-center">
                                <Logo/>
                            </div>
                        </div>

                        <div className="flex-shrink-0 ml-4 mt-2">
                            <button onClick={toggleMenu}
                                    type="button"
                                    className="rounded-full p-3 text-sm inline-flex items-center"
                                    style={{
                                        background: (tourSettings?.header_background_contrast_color) ? tourSettings.header_background_contrast_color : '#f3f4f6'
                            }}
                                    data-modal-hide="staticModal">
                                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"></path>
                                </svg>
                            </button>
                        </div>



            </div>
            </div>

            <div className="menu-content h-full text-center p-8 space-y-8"  style={{ "background": (tourSettings?.header_background_contrast_color) ? tourSettings.header_background_contrast_color : '#f3f4f6' }}>

                <LanguageSwitcher borderColor={`${ (tourSettings.header_text_color) ? tourSettings.header_text_color : '#000000'}`}/>

                <div className="text-2xl font-bold" onClick={showPoints}>
                    {t('points')}
                </div>

                {( tourSettings.introduction_page_id ) &&

                    <div className="text-2xl font-bold" onClick={showInfo}>
                        {t(`information`)}
                    </div>
                }

            </div>


            <div className="absolute text-center w-full bottom-10">
                <svg xmlns="http://www.w3.org/2000/svg" width="94" height="20" viewBox="0 0 94 20"  style={{ display: 'inline', fill: (tourSettings.header_text_color) ? tourSettings.header_text_color : '#000000'}}>
                    <path d="M2.19677 2.21096C1.37607 3.0367 0.769706 4.02015 0.403976 5.09316C0.135455 5.79139 0 6.61097 0 7.54845C0 8.99436 0.377417 10.5346 1.12136 12.126C1.70223 13.3676 2.50806 14.6462 3.51654 15.9261C5.21956 18.0879 6.90373 19.5025 6.97464 19.5616L7.49973 20L8.02483 19.5616C8.09601 19.5025 9.77991 18.0879 11.4832 15.9261C12.4917 14.6462 13.2975 13.3676 13.8781 12.126C14.6223 10.5346 15 8.99436 15 7.54845C15 5.53209 14.2197 3.63656 12.803 2.21096C11.3865 0.785103 9.50315 0 7.49973 0C5.49658 0 3.61322 0.785103 2.19677 2.21096ZM7.49973 1.65602C10.7284 1.65602 13.3546 4.29923 13.3546 7.54845C13.3546 8.49528 13.1554 9.44211 12.8285 10.3601C12.8239 9.15742 12.5615 8.16247 12.2699 7.42629C11.6734 5.9205 10.6381 4.6152 9.2766 3.65153C8.00066 2.7488 6.57518 2.2516 5.26259 2.2516C5.14758 2.2516 5.03471 2.254 4.92395 2.25774C5.70163 1.87254 6.57624 1.65602 7.49973 1.65602ZM9.96981 9.64527C9.12759 8.05769 7.8227 6.62728 6.29498 5.61736C5.15954 4.86674 4.01985 4.44198 3.03262 4.38397C3.58798 4.068 4.33538 3.90761 5.26259 3.90761C7.15127 3.90761 9.71722 5.45296 10.7416 8.03951C11.2787 9.39533 11.331 10.8567 10.8981 12.3855C10.7563 11.4649 10.4447 10.5405 9.96981 9.64527ZM1.64512 7.54845C1.64512 6.27041 2.22997 6.12339 2.42174 6.07474C3.12239 5.89831 4.26048 6.25358 5.39193 7.00152C6.67425 7.84918 7.81421 9.09727 8.51831 10.425C9.19187 11.695 9.45986 13.0175 9.29359 14.2498C9.12892 15.4677 8.54965 16.6225 7.56906 17.6923C7.53718 17.7251 7.50585 17.758 7.47371 17.7909C5.92367 16.3418 1.64512 11.9431 1.64512 7.54845Z" />
                    <path d="M26.3638 20C23.664 20 22.2039 18.6612 22.2039 16.1202V10.1366H20V6.47541H22.2039V2.86885H26.4189V6.47541H29.1186V10.1366H26.4189V14.9454C26.4189 15.7104 26.8596 16.2842 27.6035 16.2842C28.0718 16.2842 28.5401 16.1202 28.6779 15.9563L29.5043 19.1257C28.9809 19.6175 27.934 20 26.3638 20Z"/>
                    <path d="M37.3379 20C32.8199 20 30.0925 16.776 30.0925 13.0601C30.0925 9.34426 32.8199 6.14754 37.3379 6.14754C41.911 6.14754 44.6107 9.34426 44.6107 13.0601C44.6107 16.776 41.911 20 37.3379 20ZM37.3379 16.2842C39.2112 16.2842 40.258 14.8361 40.258 13.0601C40.258 11.3115 39.2112 9.86339 37.3379 9.86339C35.4921 9.86339 34.4728 11.3115 34.4728 13.0601C34.4728 14.8361 35.4921 16.2842 37.3379 16.2842Z" />
                    <path d="M59.7948 19.6721H55.5523V18.0874C54.7259 19.0164 53.1831 20 50.9517 20C47.9213 20 46.5714 18.306 46.5714 15.8743V6.47541H50.8139V14.153C50.8139 15.7377 51.6404 16.2842 53.0178 16.2842C54.23 16.2842 55.0565 15.6284 55.5523 15V6.47541H59.7948V19.6721Z" />
                    <path d="M66.8417 19.6721H62.5992V6.47541H66.8417V8.14208C67.7233 7.0765 69.4038 6.14754 71.0016 6.14754V10.2186C70.7537 10.1366 70.3955 10.082 69.9547 10.082C68.8528 10.082 67.3927 10.5464 66.8417 11.3115V19.6721Z" />
                    <path d="M74.7758 4.80874C73.4259 4.80874 72.3515 3.74317 72.3515 2.40437C72.3515 1.06557 73.4259 0 74.7758 0C76.1257 0 77.2001 1.06557 77.2001 2.40437C77.2001 3.74317 76.1257 4.80874 74.7758 4.80874ZM76.897 19.6721H72.6545V6.47541H76.897V19.6721Z" />
                    <path d="M86.0604 20C81.5425 20 78.8151 16.776 78.8151 13.0601C78.8151 9.34426 81.5425 6.14754 86.0604 6.14754C90.6335 6.14754 93.3333 9.34426 93.3333 13.0601C93.3333 16.776 90.6335 20 86.0604 20ZM86.0604 16.2842C87.9338 16.2842 88.9806 14.8361 88.9806 13.0601C88.9806 11.3115 87.9338 9.86339 86.0604 9.86339C84.2147 9.86339 83.1954 11.3115 83.1954 13.0601C83.1954 14.8361 84.2147 16.2842 86.0604 16.2842Z" />
                </svg>
            </div>

        </div>
    );
};

export default Menu;